import {
  Box,
  Center,
  CircularProgress,
  CircularProgressLabel,
  Flex,
  Heading,
  Image,
  Progress,
  Spacer,
  Text,
} from "@chakra-ui/react";
import {
  franchiseMapIndex,
  titleSingleMapIndex,
} from "../../../core/constants";
import ReadingOrderCoverPlaceholder from "../../../resources/images/placeholder-cover.jpg";

const ReadingOrderHeader = ({
  readingOrder,
  progress,
  totalComics,
  hideProgress,
  showFranchise,
  callToAction,
  coverHeight,
}) => {
  return (
    <Box position="relative">
      {/* Overlay content */}
      <Box
        h="100%"
        w="100%"
        bgGradient="linear(to-t, black, transparent)"
        position="absolute"
        top="0"
        left="0"
      >
        <Box w="100%" position="absolute" bottom="0">
          <Flex p="6">
            <Box>
              <Heading as="h3">{readingOrder?.title}</Heading>
              <Text fontSize="sm">
                {!!showFranchise &&
                  !!readingOrder?.franchise &&
                  !!readingOrder?.type &&
                  `${franchiseMapIndex[readingOrder.franchise]} • ${
                    titleSingleMapIndex[readingOrder.type]
                  } • `}
                {!!totalComics && ` ${totalComics} comics`}
                {!!readingOrder?.years && ` • ${readingOrder?.years}`}
              </Text>
            </Box>
            <Spacer />
            <Center fontSize="xs">
              {!hideProgress && (
                <CircularProgress
                  value={progress}
                  color="red.500"
                  trackColor="gray.700"
                >
                  <CircularProgressLabel fontSize="xs">
                    {progress}%
                  </CircularProgressLabel>
                </CircularProgress>
              )}
              {!!callToAction && callToAction}
            </Center>
          </Flex>
          {!hideProgress && (
            <Progress size="sm" height="3px" value={progress} />
          )}
        </Box>
      </Box>

      {/* Backgroung image */}
      <Image
        src={readingOrder?.thumbnail || ReadingOrderCoverPlaceholder}
        alt="Banner"
        objectFit="cover"
        width="100%"
        borderRadius="lg"
        minHeight={150}
        height={coverHeight || "100%"}
      />
    </Box>
  );
};

export default ReadingOrderHeader;
